import { Spin, Typography, theme } from 'antd';
import { useT } from '../locales';

const { Text } = Typography;

export function LoadingScreen() {
  const t = useT();
  const { token } = theme.useToken();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 16,
        minHeight: '100vh',
        background: token.colorBgLayout,
      }}
    >
      <Spin size="large" />
      <Text type="secondary" style={{ fontSize: 13 }}>
        {t('loading.loading')}
      </Text>
    </div>
  );
}
